import { signInWithEmailAndPassword } from 'firebase/auth';
import React from 'react'
import { useDispatch } from 'react-redux';
import { auth } from '../../firebase/firebaseConfig';
import { setErrorMsg, setHasErrored } from '../../redux/errorReducer/errorSlice';
import { setIsLoading, setLoadingMsg } from '../../redux/loaderReducer/loaderSlice';
import "./Login.scss"
const Login = () => {
    const [userCredentials,setUserCredentials] = React.useState({
        email:"",
        password:""
    })
    const  [formErrors,setFormErrors] = React.useState({});
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const dispatch = useDispatch()

   const handleChange = e => {
        setUserCredentials({...userCredentials,
        [e.target.name]:e.target.value})
    }
    const validate = (userCredentials) => {
        const errors = {}
        if(!userCredentials.email.length){
            errors.email = "Email is required!"
        }
        else if(!regex.test(userCredentials.email)){
            errors.email = "Email format is invalid!"
        }
        else if(!userCredentials.password.length) {
            errors.password = "Password is required!"
        }
        else if (userCredentials.password.length < 6) {
            errors.password = "Password is too short! "
        }
        return errors;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validation = validate(userCredentials);
        if(Object.keys(validation).length > 0){
            setFormErrors(validation);
            return;
        }
        try {
            dispatch(setIsLoading(true));
            dispatch(setLoadingMsg('signing in...'))
            const {email, password} = userCredentials;
            await signInWithEmailAndPassword(auth,email,password);
        } catch (error) {
            dispatch(setHasErrored(true));
            dispatch(setErrorMsg(error.message))
            dispatch(setIsLoading(false));
            dispatch(setLoadingMsg(null));
        }
             dispatch(setIsLoading(false));
            dispatch(setLoadingMsg(null))
            setUserCredentials({...userCredentials,email:"",password:""})
    }
  return (
    <div className="login-container">
     
        <div className="form-container">
        <div className="form-title">
                <h1>Login</h1>
            </div>
            <div className="formNimg">
            <form onSubmit={handleSubmit} className="form">
           
       
           <div className="form-group">
               <label htmlFor="email" className="form-label">Email:</label>
               <input onChange={handleChange} value={userCredentials.email} type="email" name="email" id="email" className="form-control" />
                <p className={`${formErrors.email ? 'form-input-error':'hide'}`}>{formErrors.email}</p>
           </div>
           <div className="form-group">
               <label htmlFor="password" className="form-label">Password:</label>
               <input onChange={handleChange} value={userCredentials.password} type="password" name="password" id="password" className="form-control" />
                <p className={`${formErrors.password ? 'form-input-error':'hide'}`}>{formErrors.password}</p>
           </div>
        
           <div className="form-btn-container">
            <button type='submit' className="form-btn">Login</button>
           </div>
       </form>
       <div className="img-container">
       <object className='form-svg' aria-label="svg animtaed picture" data="./brain.svg" type="image/svg+xml"></object>
       <p>Smart Brain</p>
       </div>
            </div>

        </div>
        </div>
   
  )
}

export default Login